module.exports = __webpack_public_path__ + "media/map/marker-icon-2x-blue-69c430ad.png";